export enum ENV {
  development = 'development',
  stage = 'stage',
  production = 'production',
}
